import { ButtonBase, styled as muiStyled } from '@mui/material'

export const UIScreenshotsSectionButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  padding: 12px 36px;
  background: #705DBB;
  color: #fff;
  border-radius: 50px;
  letter-spacing: 2px;
  margin: 24px auto 0;
  border: 1px solid transparent;
  transition: all 400ms ${theme.transitions.easing.quickInOut};
  &:hover {
    border: 1px solid #fff;
    background: transparent;
  }

  @media(min-width: 768px) {
    margin: 24px 0 0;
  align-self: flex-start;
  }
`,
)
